import Picker from '@components/input/picker.input.jsx';
import { isYes } from '@util/common.js';
import Button from '@components/buttons/button.jsx';
import PropTypes from 'prop-types';
import YesNoButtonInput from '@components/input/yes-no-button.input.jsx';

TwitchChatbotSettings.propTypes = {
  config: PropTypes.shape({
    donationOnOff: PropTypes.string,
    timerOptions: PropTypes.string,
    milestoneMessages: PropTypes.string,
  }).isRequired,
  chatbotConnected: PropTypes.bool.isRequired,
  setConfigState: PropTypes.func.isRequired,
  connectChatbot: PropTypes.func.isRequired,
  disableConnectionButton: PropTypes.bool.isRequired,
};
export default function TwitchChatbotSettings({
  config,
  chatbotConnected,
  setConfigState,
  connectChatbot,
  disableConnectionButton,
}) {
  const timerOptions = [
    {
      value: '5',
      name: 'Five minutes',
    },
    {
      value: '10',
      name: 'Ten minutes',
    },
    {
      value: '15',
      name: 'Fifteen minutes',
    },
  ];

  return (
    <>
      <div className="flex flex-col md:flex-row">
        <YesNoButtonInput
          disabled={chatbotConnected}
          mode="checkbox"
          onChange={setConfigState}
          currentValue={config.donationOnOff}
          name="donationOnOff"
          className="md:mr-4 mb-2 md:mb-0 flex-1"
          label="Post donation link at specific intervals"
        />
        <YesNoButtonInput
          disabled={chatbotConnected}
          mode="checkbox"
          onChange={setConfigState}
          currentValue={config.milestoneMessages}
          name="milestoneMessages"
          className="flex-1"
          label="Post milestone messages"
        />
      </div>
      <div className="mt-1">
        <Picker
          items={timerOptions}
          fieldName="timerOptions"
          onChange={setConfigState}
          currentValue={config.timerOptions}
          labelText="Message Timer"
          disabled={!isYes(config.donationOnOff) || chatbotConnected}
        />
        <article className="prose text-sm mt-2 ml-1">
          Set the desired minutes before message repeats
        </article>
      </div>

      <Button
        onClick={connectChatbot}
        mode="button"
        style="primary"
        className="mt-5"
        analyticsTrackingName="connect-twitch-chatbot"
        disabled={disableConnectionButton}
      >
        Connect Chatbot
      </Button>
    </>
  );
}
